module.exports = __webpack_public_path__ + "img/bomen snoeien.56a28f3c.jpg";